import ds from 'Shared/ds';

export default class SalesRepApi {
    static accounts = (data) => {
        return ds.get(this.#const.DATA, data);
    };

    static #const = {
        DATA: "/salesrep/accounts",
    };
}